
import { QuickUsageTracker } from "@/components/dashboard/usage-tracker";

interface UsageSectionProps {
  onUsageRecorded: () => void;
}

const UsageSection = ({ onUsageRecorded }: UsageSectionProps) => {
  return <QuickUsageTracker />;
};

export default UsageSection;
